import { render, staticRenderFns } from "./rtc-switch.vue?vue&type=template&id=6996aa1d&scoped=true&"
import script from "./rtc-switch.vue?vue&type=script&lang=js&"
export * from "./rtc-switch.vue?vue&type=script&lang=js&"
import style0 from "./rtc-switch.vue?vue&type=style&index=0&id=6996aa1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996aa1d",
  null
  
)

export default component.exports